import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css';
import Pagination from './../../../../shared/components/pagination';
import CustomExpandableTable from '../../../../shared/components/customExpandableTable';
import Loader from '../../../../shared/components/loader';
import AdminSettingsService from '../../../../adminsettings/services/adminsettings.service';
import CONSTANT from '../../../../shared/constants/constant';
import Util from '../../../../shared/util/util';
import MasterService from '../../../../masterdata/services/masterdata.service';
import CryptoJS from 'crypto-js';
import TripServices from '../../../services/firstAndLastmilemanagement.service';
import DatePicker from 'vue2-datepicker';
import moment from 'moment';
import XLSX from 'xlsx';
export default {
  name: 'DTHhubMapping',
  components: {
    Pagination,
    Loader,
    Multiselect,
    CustomExpandableTable,
	DatePicker
  },
  data: function() {
    return {
      tableArr: [],
       selectedODAObj: '',
       type:'DTH_Mapping',
       isLoading:false,
       Loader:false,
       showcreatedthconfig: false,
      currentPage: 1,
      totalPage: 0,
      totalCount:0,
      offset:0,
      pageLimit:CONSTANT.PER_PAGE_DATA,
      tableColumn: ['AWB', 'MPS', 'Client Ref. No','Route Mode','Booking Mode','Client Name','Origin','Destination','Phy Weight (kg)','Vol Weight (kg)','PDD Date','Appointment Date','Action'],
      innerTableColumn: ['Assigned Territory'],
      tableItems: [],
      hubaccessObjArray:[],
      hubids:null,
      motherhubArr:[],
      motherhubids:null,
      UpdateDTHMapping:"",
      actiontype:"",
      useremail: "",
	  selectedAWB: [],
      awberr: "",
      pageLimit: CONSTANT.PER_PAGE_HTD_DATA,
      isAllSelected: "",
      seletedAWB: [],
      selectedRemoveAWB: [],
      isAllAddedSelected: "",
	  shipmentselected:0,
	  hubname:'',
	  shipmentselected:0,
	  companyNamelist:[],
	  ClientName: null,
	  AWB:'',
	  hubids:null,
	  motherhubArr:[],
	  motherhubids:null,
	  shortcuts:false,
	  appointmentDate:'',
	  radDate:'',
	  popuptype:0,
	  removehtdModal:false,
	  removehtdProgressModal:'',
	  promiseArray:[],
	  promiseAwbList:[],
	  promiseresultstatus:[],
	  popuptype:0,
	  Promiseinprogress:true,
	  updateCounter: 0,
	  currenthubinscandate:'',
	  disabledHubInscandate:new Date(),
	  controllingHub:[]
    }
  },
  computed: {

  },
  async mounted() {
  var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
  var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
  var plaintext = bytes.toString(CryptoJS.enc.Utf8);
  var userdetail = JSON.parse(plaintext);
  this.useremail = userdetail.email;
//  this.defaultHubID = userdetail.hubID[0];
    this.hubname = userdetail.currentHubName;
  	this.hubid = userdetail.hubID[0];
  	this.userid = userdetail.userid;
  	this.useremail = userdetail.email;
	this.getHTDWaybills();
	this.getCompanyShortName();
	this.getHubAccessList();
  },
  methods: {
	isIntegerOnly: function (evt) {
		evt = evt ? evt : window.event;
		var charCode = evt.which ? evt.which : evt.keyCode;
		if (charCode == 13) {
		  evt.preventDefault();
		} else {
		  return true;
		}
	  },
	  allowedappointmentDates(date) {
		var Difference_In_Time = date[1].getTime() - date[0].getTime(); 
		var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24); 
		if(Difference_In_Days > 30){
			this.$alertify.error("Max 30 days can be selected");
			this.appointmentDate='';
		}
	  },
	  allowedinScanDates(date) {
		var Difference_In_Time = date[1].getTime() - date[0].getTime(); 
		var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24); 
		if(Difference_In_Days > 30){
			this.$alertify.error("Max 30 days can be selected");
			this.currenthubinscandate='';
		}
	  },
	  select() {
		if (this.isAllSelected) {
		  this.isAllSelected = 0;
		}
	  },
	  selectAll() {
		if (this.isAllSelected) {
		  this.tableItems.forEach((item) => {
			if (this.selectedAWB.some((el) => el.AWB == item.AWB)) {
			  return;
			} else {
			  this.selectedAWB.push(item);
			}
		  });
		} else {
		  this.selectedAWB = this.selectedAWB.filter((item) => {
			if (this.tableItems.some((el) => el.AWB == item.AWB)) {
			  return false;
			} else {
				this.selectedAWB.pop(item);
			}
		  });
		}
	  },
	  selectRemove() {
		if (this.isAllAddedSelected) {
		  this.isAllAddedSelected = 0;
		}
	  },
    async getHubAccessList() {
      try {
		let InputPayload = {};
        this.isLoading = true;
			let response = await MasterService.GetHublist(InputPayload);
			if (response.data.code === 200) {
			  this.hubaccess = response.data.data.data;
			  for (var i = 0; i < this.hubaccess.length; i++) {
				this.hubaccessObjArray.push({
				  hubid: this.hubaccess[i].HubID,
				  hubname: this.hubaccess[i].HubName
				})
			  }
			}
			else {
			  this.$alertify.error(response.data.message);
			}
      } catch(err){
        console.log(err);
        this.isLoading = false;
      }
    },
      onPageChange(page) {
        this.currentPage = page;
        this.offset = (page - 1) *this.pageLimit
		this.selectedAWB =[]
	    this.isAllSelected=false;
	    this.selectAll();
        this.getHTDWaybills()
      },
	  async DownloadLogs() {
		try {
		} catch (error) {
		  console.log(err);
		}
	  },
	  async getHTDWaybills() {
        this.isLoading = true
        this.totalCount=0;
        try {
          let inputPayload = {
            "offset": this.offset,
            "limit": this.pageLimit,
			"type":"htdmarked",
			"isexport":0
          } 
		  inputPayload.hubid = this.hubid
		  if(this.AWB!=null && this.AWB!=''){
			let awbnumbers = this.AWB.trim().split(/[\n,' ']+/)
			let awbarr = awbnumbers.filter(function (n) { return n !== "" });
			if(awbarr.length>20){
			  this.$alertify.error("Maximum 20 AWB Allowed","","error");
			}else{
			  inputPayload.awb = awbarr
			}
		  }
		if(this.ClientName){
			inputPayload.clientid = this.ClientName.id
		}
		if(this.hubids){
			inputPayload.destinationhubid = this.hubids.hubid
		}
		if(this.currenthubinscandate[0]){
			inputPayload.currentfromdate = moment(this.currenthubinscandate[0]).format('YYYY-MM-DD')
			inputPayload.currenttodate =moment(this.currenthubinscandate[1]).format('YYYY-MM-DD')
		}
		if(this.appointmentDate[0]){
			inputPayload.appointmentfromdate = moment(this.appointmentDate[0]).format('YYYY-MM-DD')
			inputPayload.appointmenttodate = moment(this.appointmentDate[1]).format('YYYY-MM-DD')
		}  
          let result = await TripServices.getHTDEwabillsList(inputPayload);
          this.isLoading = false;
            if(result.data.code == 200){
              this.totalCount = result.data.data.count;
              this.tableArr = result.data.data.rows;
			  this.controllingHub = result.data.data.controllinghub
            this.tableItems = result.data.data.rows.map((el)=>{
              return {
                'AWB': el.awb,
                'MPS': el.mpscount,
                'ClientRefNo': el.clientreference,
                'RouteMode': el.routemode,
                'BookingMode': el.bookingmode,
                'ClientName': el.clientname,
                'Origin':el.originhubname,
                'OriginHubId':el.originhubid,
                'Destination': el.destinationhubname,
                'DestinationHubId':el.destinationhubid,
                'PhyWt': el.physicalwt,
                'VolWt': el.volumetricwt,
                'PDDDate':el.pdddate ? moment(el.pdddate).format('YYYY-MM-DD') : null,
				'CurrentHubinscandate':el.currenthubinscandate ? moment(el.currenthubinscandate).format('YYYY-MM-DD'):null,
                'AppointmentDate': el.appointmentdate ? moment(el.appointmentdate).format('YYYY-MM-DD'):null,
				'clientid': el.clientid,
				'clientbusinessaccountid': el.clientbusinessaccountid,
              }
            })
          }else{
            this.$alertify.error("No Shipment found");
            this.tableItems=[];
          }
		  this.AWB='';
          if (this.totalCount < this.pageLimit) {
            this.totalPage = 1
          } else {
            this.totalPage = Math.ceil(this.totalCount / this.pageLimit);
          }
        } catch (err) {
          this.isLoading = false;
          console.log(err);
        }
      },
	  async removeHTDShipments(data){
		try {
			let message = "<div style='padding-top:20px;'>Selected Shipments will be removed from the list</p></div>";
			this.$fire({
				//html: message + "<b>"+`${data.toString()}`  +"</b>",
				html:message,
				textalign: 'center',
				showCancelButton: true,
				confirmButtonText: 'Confirm',
				cancelButtonText: 'Cancel',
				reverseButtons: true
				}).then(async(result)  => {
						if(result.value == true) {
							this.Promiseinprogress=true;
							let promiseArr=[]
							this.removehtdModal = true
						  for(let i=0;i<data.length;i++){
							let inputPayload = {};
							inputPayload.awb = data[i].AWB;
							inputPayload.mpscount = data[i].MPS;
							inputPayload.routemode = data[i].RouteMode;
							inputPayload.bookingmode = data[i].BookingMode;
							inputPayload.clientid = data[i].clientid;
							inputPayload.clientbusinessaccountid = data[i].clientbusinessaccountid;
							inputPayload.clientname = data[i].ClientName;
							inputPayload.originhubid = data[i].OriginHubId;
							inputPayload.destinationhubid = data[i].DestinationHubId;
							inputPayload.currenthubid = this.hubid;
							inputPayload.physicalwt = data[i].PhyWt;
							inputPayload.volumetricwt = data[i].VolWt;
							inputPayload.currenthubname = this.hubname;
							inputPayload.type = "removehtd";
							inputPayload.lastmodifiedby = this.useremail;
							(inputPayload.currenthubinscandate = data[i].currenthubinscandate ? moment(data[i].currenthubinscandate).format('YYYY-MM-DD'):null),
							inputPayload.comment="Removing HTD",
							(inputPayload.appointmentdate = data[i].AppointmentDate ? moment(data[i].AppointmentDate).format('YYYY-MM-DD'):null);
							this.promiseAwbList.push(data[i].AWB);
							this.promiseresultstatus.push({awb: data[i].AWB, status: 'In Progress', message: 'In Progress'})
							this.markRemoveHTDApi(inputPayload)
							this.isLoading = false;
						  }
							//this.unselectHTDShipment();
  
						}else{
						  this.unselectHTDShipment()
						  return false;
						}
					  }).catch((err)=>{
					   console.log(err)
					 });
		} catch (error) {
		  console.log(error);
		}
	  },
	  async markRemoveHTDApi(input) {
		try {
		  let result = await TripServices.markRemoveHTD(input)
		  for (let index = 0; index < this.promiseresultstatus.length; index++) {
			if (result.code == 200) {
			  if (this.promiseresultstatus[index].awb == input.awb) {
				this.updateCounter=this.updateCounter+1;
				this.$set(this.promiseresultstatus, index, { awb: this.promiseresultstatus[index].awb, status: result.status , message: result.message });
			  }
			} else {
			  if (this.promiseresultstatus[index].awb == input.awb) {
				this.updateCounter=this.updateCounter+1;
				this.$set(this.promiseresultstatus, index, { awb: this.promiseresultstatus[index].awb, status: result.status , message: result.message });
			  }
			}
		  }
		  if (this.updateCounter == this.promiseresultstatus.length) {
            this.Promiseinprogress = false;
			this.getHTDWaybills()
          }
		} catch (error) {
		 for (let index = 0; index < this.promiseresultstatus.length; index++) {
		  if (this.promiseresultstatus[index].awb == input.awb) {
			this.updateCounter=this.updateCounter+1;
			this.$set(this.promiseresultstatus, index, { awb: data[i].AWB, status: 'Failed', message: 'Internal server error.' });
			if (this.updateCounter == this.promiseresultstatus.length) {
				this.Promiseinprogress = false;
				this.getHTDWaybills()
			}
		  }
		 }
		}
	  },
  
	  async removeHTD(data,type){
		try {
			this.isLoading = true;
			if(type == 1){
				this.removeHTDShipments(data);
			}else if(type ==2){
				this.removeHTDShipments([data]);
			}
			this.isLoading = false;
		  } catch (error) {
			this.isLoading = false;
			console.log(error);
		  }
	  },
	  async getCompanyShortName() {
		try {
			var CompanyShortList = [];
			let result = await TripServices.getActiveInactiveClientList()
			CompanyShortList = result.data.data;
			for (var i = 0; i < CompanyShortList.length; i++) {
			this.companyNamelist.push({
				'id': CompanyShortList[i].ClientMasterID,
				'label': CompanyShortList[i].ClientShortName,
				'CompanyName': CompanyShortList[i].CompanyName
			})
			}
		} catch (err) {
			console.log(err);
		}
	  },
		resetFilter(){
		this.currentPage = 1;
		this.offset = 0;
		this.AWB = '';
		this.ClientName = null;
		this.hubids = '',
		this.appointmentDate = '';
		this.radDate=''
		this.currenthubinscandate = ''
		this.getHTDWaybills();
	  },
	  closeremovehtd() {
		this.removehtdModal = false;
		this.updateCounter= 0;
		this.resetremovehtd();
	  },
	  resetremovehtd() {
		this.selectedAWB =[]
		this.isAllSelected=false;
	  this.promiseArray=[];
	  this.promiseAwbList=[];
	  this.promiseresultstatus=[];
		this.selectAll();
	  },
	  async unselectHTDShipment(data){
		this.selectedAWB =[]
		this.isAllSelected=false;
		this.selectAll();
	  },
	  async DownloadHTDData(){
		try {
		  this.isLoading = true;
		  this.totalCount = 0;
		  let inputPayload = {
			offset: this.offset,
			limit: this.totalCount,
			type: "htdmarked",
			"isexport":0
		  };
		  inputPayload.hubid = this.hubid
		  if(this.AWB!=null && this.AWB!=''){
			  let awbnumbers = this.AWB.trim().split(/[\n,' ']+/)
			  let awbarr = awbnumbers.filter(function (n) { return n !== "" });
			  if(awbarr.length>20){
				this.$alertify.error("Maximum 20 AWB Allowed","","error");
				this.isLoading = false;
			  }else{
				inputPayload.awb = awbarr
			  }
		  }
		  if(this.ClientName){
			  inputPayload.clientid = this.ClientName.id
		  }
		  if(this.hubids){
			inputPayload.destinationhubid = this.hubids.hubid
		  }
		  if(this.currenthubinscandate[0]){
			inputPayload.currentfromdate = moment(this.currenthubinscandate[0]).format('YYYY-MM-DD')
			inputPayload.currenttodate =moment(this.currenthubinscandate[1]).format('YYYY-MM-DD')
		}
		  if(this.appointmentDate[0]){
			  inputPayload.appointmentfromdate = moment(this.appointmentDate[0]).format('YYYY-MM-DD')
			  inputPayload.appointmenttodate = moment(this.appointmentDate[1]).format('YYYY-MM-DD')
		  }
		  let result = await TripServices.getHTDEwabillsList(
			inputPayload
		  );
		  this.isLoading = false;
		  if (result.data.code == 200) {
			this.totalCount = parseInt(result.data.data.count);
			let tempdata = result.data.data.rows.map((el) => {
			  return {
                'AWB': el.awb,
                'MPS': el.mpscount,
                'ClientRefNo': el.clientreference,
                'RouteMode': el.routemode,
                'BookingMode': el.bookingmode,
                'ClientName': el.clientname,
                'Origin':el.originhubname,
                'OriginHubId':el.originhubid,
                'Destination': el.destinationhubname,
                'DestinationHubId':el.destinationhubid,
                'PhyWt': el.physicalwt,
                'VolWt': el.volumetricwt,
				'PDDDate': el.pdddate ? moment(el.pdddate).format('YYYY-MM-DD'):null,
				'Current Hub Inscan Date': el.currenthubinscandate ? moment(el.currenthubinscandate).format('YYYY-MM-DD'):null,
				'AppointmentDate': el.appointmentdate ? moment(el.appointmentdate).format('YYYY-MM-DD'):null,
			  };
			});
			let dt = moment().tz('Asia/Kolkata').format('YYYYMMDDHHmmss');
			const data = XLSX.utils.json_to_sheet(tempdata);
			const wb = XLSX.utils.book_new();
			XLSX.utils.book_append_sheet(wb, data, 'data')
			XLSX.writeFile(wb,dt+'_HTDdata.xlsx');
		  }else{
			this.$alertify.error("No Data Found")
		  }
	  this.isLoading = false;
	} catch(err){
	  console.log(err);
	  this.isLoading = false;
	}
  },
  }
}



// WEBPACK FOOTER //
// ./src/modules/firstAndLastmilemanagement/views/htdawblevelmarking/htdwaybills/htdwaybills.component.js